import {
  ContextMenuHeader,
  ContextMenuItemList,
  ContextMenuItemSubmenu,
  ContextMenuSeparator,
} from './ContextMenuProvider.types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isMenuSeparator(item: ContextMenuItemList<any>): item is ContextMenuSeparator {
  return (item as ContextMenuSeparator).type === 'separator';
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isMenuHeader(item: ContextMenuItemList<any>): item is ContextMenuHeader {
  return (item as ContextMenuHeader).type === 'header';
}

export function isSubmenuItem<T>(item: ContextMenuItemList<T>): item is ContextMenuItemSubmenu<T> {
  return (item as ContextMenuItemSubmenu<T>).type === 'submenu';
}
